export default "__VITE_ASSET__ff698e00__"